import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">精彩视频</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">91视频、97视频、51视频精选内容预览</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 md:gap-5">
          {mediaData.map((item) => (
            <a
              key={item.id}
              href="#media"
              onClick={(e) => e.preventDefault()}
              className="group block rounded-2xl overflow-hidden bg-background-100 border border-background-200/60 hover:border-primary-200/40 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video bg-background-900 flex items-center justify-center overflow-hidden">
                <div className="absolute inset-0 bg-gradient-to-br from-background-800 via-background-900 to-background-950"></div>
                <div className="absolute inset-0 opacity-15">
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-32 h-32 rounded-full bg-primary-500/30 blur-3xl"></div>
                </div>

                <div className="relative z-10 w-14 h-14 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:scale-110 transition-all duration-300">
                  <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                </div>

                <div className="absolute bottom-2 right-3 px-2 py-0.5 rounded bg-background-950/70 text-background-200/80 text-[10px] font-medium whitespace-nowrap">
                  {item.duration}
                </div>
              </div>

              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <div className="flex items-center gap-1">
                  <i className="ri-eye-line text-foreground-400 text-xs"></i>
                  <span className="text-xs text-foreground-400">{item.views}次播放</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}